import { createReducer, on } from '@ngrx/store';
import * as LinksActions from './links.actions';
import { initialLinksState } from './links.state';

export const linksReducer = createReducer(
  initialLinksState,

  on(LinksActions.loadLinks, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(LinksActions.loadLinksSuccess, (state, { links, pagination }) => ({
    ...state,
    links,
    pagination,
    loading: false,
    error: null,
  })),

  on(LinksActions.loadLinksFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(LinksActions.createLink, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(LinksActions.createLinkSuccess, (state, { link }) => ({
    ...state,
    links: [ ...state.links, link ],
    loading: false,
    error: null,
  })),

  on(LinksActions.createLinkFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(LinksActions.updateLink, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(LinksActions.updateLinkSuccess, (state, { link }) => ({
    ...state,
    links: state.links.map(l => l.id === link.id ? link : l),
    loading: false,
    error: null,
  })),

  on(LinksActions.updateLinkFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(LinksActions.deleteLink, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(LinksActions.deleteLinkSuccess, (state, { id }) => ({
    ...state,
    links: state.links.filter(l => l.id !== id),
    loading: false,
    error: null,
  })),

  on(LinksActions.deleteLinkFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(LinksActions.uploadImageSuccess, (state, { link }) => ({
    ...state,
    links: state.links.map(l => l.id === link.id ? link : l),
  })),

  on(LinksActions.uploadImageFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  on(LinksActions.deleteImageSuccess, (state, { link }) => ({
    ...state,
    links: state.links.map(l => l.id === link.id ? link : l),
  })),

  on(LinksActions.deleteImageFailure, (state, { error }) => ({
    ...state,
    error,
  })),
);
